import { EmptyStateContext } from "./empty-state.context";

import type { EmptyStateProviderProps } from "../empty-state.types";

export function EmptyStateProvider({
  children,
  size,
}: Readonly<EmptyStateProviderProps>) {
  return (
    <EmptyStateContext.Provider value={{ size }}>
      {children}
    </EmptyStateContext.Provider>
  );
}
